import { Skeleton } from '@lastbrand/web-ui/skeleton'
import classnames from 'classnames'

import * as styles from './purchase-type-selector-ds.styles'

import type { PurchaseTypeSelectorShimmerProps } from './purchase-type-selector.types'

// Placeholder heights approximating the two selector cards (expanded subscribe + collapsed one-time).
// No DS spacing token maps to these exact loader dimensions, so they stay as raw px (parity with legacy).
const SUBSCRIBE_CARD_HEIGHT = '124px'
const ONE_TIME_CARD_HEIGHT = '42px'

export const PurchaseTypeSelectorShimmerDS = ({
  showShimmer,
  isFromPdp,
  children,
  showNewPdpDesignV2,
}: PurchaseTypeSelectorShimmerProps) => {
  if (!showShimmer) return children

  return (
    <div
      className={classnames(
        styles.shimmerWrapper,
        isFromPdp && styles.adjustedPaddingForMobile,
        showNewPdpDesignV2 && styles.adjustedPaddingForMobile_noPaddingRight,
      )}
    >
      <Skeleton css={{ width: 'full', height: SUBSCRIBE_CARD_HEIGHT }} />
      <Skeleton css={{ width: 'full', height: ONE_TIME_CARD_HEIGHT }} />
    </div>
  )
}
